export { default as ContainerGlobal } from './ContainerGlobal'
